
import { useStore } from 'vuex';
import { defineComponent } from 'vue';
import incredibuildLogo from '@/assets/images/icons/logo.svg';
import loginBg from '../login/loginComponents/login-bg.vue';

export default defineComponent({
  name: 'LoginWrapper',
  components: {
    loginBg,
  },
  setup() {
    const store = useStore();
    return { store };
  },
  data() {
    return {
      incredibuildLogo,
      loading: false,
    };
  },
  computed: {
    isBgColorRed() {
      switch (this.$route.name) {
        case 'login':
          return !this.store.getters['main/getCoordinatorLinkStatus'];
        case 'licenseLocked':
          return true;
        case 'licenseExpired':
          return true;
        case 'enterLicense':
          return false;
        default:
          return false;
      }
    },
  },
  methods: {
    setLoading(value: boolean) {
      this.loading = value;
    },
  },
});
